var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1168(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M302.901,882.617l613.575,0.219c-0,-0 214.331,-22.802 217.461,-234.117c3.293,-222.349 -230.389,-236.23 -236.689,-247.34c-46.801,-82.527 -78.618,-193.773 -283.849,-194.951c-254.21,-1.459 -290.41,297.369 -300.619,299.751c-76.838,17.928 -197.794,46.808 -196.508,204.812c1.289,158.365 186.629,171.626 186.629,171.626Z",
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.368,490.076c-83.137,19.788 -203.187,56.234 -201.845,221.067c0.717,88.171 52.428,136.104 104.202,161.838c49.995,24.85 99.838,28.338 99.838,28.338c0.443,0.032 0.888,0.048 1.332,0.048l613.574,0.219c0.665,-0 1.329,-0.035 1.99,-0.106c0,0 230.852,-24.723 234.226,-252.483c2.826,-190.826 -155.846,-239.573 -223.37,-257.121c-7.231,-1.879 -14.634,-3.917 -18.736,-5.064c-28.065,-50.61 -52.873,-109.837 -111.399,-150.428c-41.025,-28.452 -98.553,-48.206 -185.673,-48.706c-122.259,-0.702 -197.439,63.396 -244.035,134.556c-44.02,67.227 -61.859,140.733 -70.104,167.842Zm4.261,373.788c-5.364,-0.476 -45.215,-4.582 -85.213,-24.463c-41.219,-20.488 -82.823,-58.368 -83.395,-128.563c-1.18,-145.029 111.491,-169.943 182.02,-186.4c3.263,-0.761 7.342,-2.486 10.962,-6.961c1.373,-1.697 3.407,-5.029 5.238,-10.239c1.972,-5.612 4.628,-15.368 8.321,-28.044c21.341,-73.25 79.941,-255.118 271.729,-254.017c77.065,0.443 128.228,16.853 164.518,42.022c55.388,38.414 76.307,96.132 103.129,143.43c1.478,2.606 4.293,6.205 9.864,8.94c4.339,2.131 14.703,4.865 29.081,8.602c58.364,15.166 197.749,55.334 195.306,220.271c-2.773,187.176 -185.381,213.829 -199.796,215.642c-0.011,0.001 -611.724,-0.217 -611.724,-0.217l-0.04,-0.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M618.593,965.642l-47.125,81.623",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.925,965.395l-47.125,81.623",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.305,965.642l-47.125,81.623",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.217,965.285l46.522,81.403l46.812,-81.295l-93.334,-0.108Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1168);
export default __webpack_public_path__ + "static/media/1168.d6a4b2bd717f0ee3aa99ad0267812e1e.svg";
export { ForwardRef as ReactComponent };